const breakPoint = 767;
let resizeFlag = false;
let windowWidth = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();
// console.log(windowWidth);
// console.log(windowHeight);
// console.log("windowWidthJ：" + windowWidthJ);



// ------------------------------------------------------------------------
// preLoad
// ----- BOTH
// ------------------------------------------------------------------------
const preLoad = () => {
  $(window).on("load", function () {
    $("body").removeClass("preload");
  });
  setTimeout(function () {
    $("body").removeClass("preload");
  }, 9000);
};


// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^='#']").on("click", function () {
    var linkSpeed = 800;
    var linkHref = $(this).attr("href");
    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust = 100;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({
      scrollTop: linkPosition - linkAdjust
    }, linkSpeed, "swing");
    return false;
  });
  $(function () {
    // 別ページの場合は以下
    var urlHash = location.hash;
    if (urlHash) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function () {
        // ヘッダー固定の場合はヘッダーの高さを数値で入れる、固定でない場合は0
        var headerHight = 100;
        var target = $(urlHash);
        var position = target.offset().top - headerHight;
        $('body,html').stop().animate({
          scrollTop: position
        }, 800);
      }, 100);
    }
  });
};


// ------------------------------------------------------------------------
// pageTop
// ----- BOTH
// ------------------------------------------------------------------------
const scrollBanner = () => {
  $(window).on("scroll", function () {
    var scrollPosition = $(window).scrollTop();
    // if(windowW >= 768){
    if (scrollPosition >= 100) {
      // $(".sw-Scroll-Banner").removeClass('sw-Scroll-Banner_Hidden');
    } else {
      // $(".sw-Scroll-Banner").addClass('sw-Scroll-Banner_Hidden');
    }
    // }
  });

  // $("#st-Top,#footer-top").on("click", function(){
  //   var linkSpeed    = 500;
  //   $("html, body").animate({scrollTop: 0}, linkSpeed, "easeOutQuint");
  //   return false;
  // });

};


// ------------------------------------------------------------------------
// slideBanner
// ----- BOTH
// ------------------------------------------------------------------------
const slideBanner = () => {
  setTimeout(function () {
    $('.slider-banner').slick({
      lazyLoad: 'progressive',
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      autoplay: true,
      speed: 500,
      cssEase: 'ease',
      variableWidth: true,
      prevArrow: '<button class="slick-prev slick-arrow"></button>',
      nextArrow: '<button class="slick-next slick-arrow"></button>',
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          swipeToSlide: true,
          swipe: true,
          edgeFriction: 0.01,
        }
      }]
    });
    windowWidthJ = $(window).width();
    var slide = $('.slider-banner .slick-slide').length;
    // console.log("スライド枚数：" + slide);
    if (windowWidthJ < 768) {
      // console.log("スマホ用");
      if (slide < 2) {
        // console.log("スライダー壊しますsp");
        $('.slider-banner').slick('unslick');
      }
    } else {
      // console.log("PC用");
      if (slide < 2) {
        // console.log("スライダー壊します");
        $('.slider-banner').slick('unslick');
      } else if (slide == 2) {
        // console.log("ページャー消す");
        $('.slick-dots').hide();
      }
    }
    $('.idx-Banner').hide().fadeIn();
  }, 2000);
  $(window).resize(function () {
    windowWidthJ = $(window).width();
    var slide = $('.slick-slide').length;
    // console.log("スライド枚数2：" + slide);
    if (windowWidthJ < 768) {
      // console.log("スマホ用");
      // if(slide < 2){
      //   console.log("スライダー壊しますsp");
      //   $('.slider-banner').slick('unslick');
      // }
    } else {
      // console.log("PC用");
      if (slide < 2) {
        // console.log("スライダー壊します");
        // $('.slider-banner').slick('unslick');
      } else if (slide == 2) {
        // console.log("ページャー消す");
        $('.slick-dots').hide();
      }
    }
  });
};


// ------------------------------------------------------------------------
// slideArtist
// ----- BOTH
// ------------------------------------------------------------------------
const slideArtist = () => {
  $('.slider-artist').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: 'ease',
    variableWidth: true,
    prevArrow: '<button class="slick-prev slick-arrow"></button>',
    nextArrow: '<button class="slick-next slick-arrow"></button>',
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        swipe: true,
        edgeFriction: 0.01,
      }
    }]
  });
};



// ------------------------------------------------------------------------
// scrollAnimate
// ----- BOTH
// ------------------------------------------------------------------------
const scrollAnimate = () => {
  $(window).on('scroll load', function () {
    $('.ja-s').each(function () {
      let targetPos = $(this).offset().top;
      let scrollPos = $(window).scrollTop();
      let windowHeight = $(window).height();
      if (scrollPos > targetPos - windowHeight + windowHeight / 4) {
        $(this).addClass("animated")
      }
    });
  });
};



// ------------------------------------------------------------------------
// loadAnimate
// ----- BOTH
// ------------------------------------------------------------------------
const loadAnimate = () => {
  $(window).on('load', function () {
    $('.ja-l').each(function () {
      $(this).addClass("animated")
    });
  });
};



// ------------------------------------------------------------------------
// resizeHeader
// ----- BOTH
// ------------------------------------------------------------------------
const resizeHeader = () => {
  $(window).on("load scroll", function () {
    let scrollHeight = $(this).scrollTop();
    if (scrollHeight > 200) {
      $(".st-Header_Menu").addClass("scrolled");
    } else {
      $(".st-Header_Menu").removeClass("scrolled");
    }
  });
};


// ------------------------------------------------------------------------
// toggleAccordion
// ----- BOTH
// ------------------------------------------------------------------------
const toggleAccordion = () => {
  $(".accordion-toggle").on("click", function () {
    $(this).next().slideToggle();
    $(this).toggleClass("open");
  });
};


// ------------------------------------------------------------------------
// toggleMenu
// ----- BOTH
// ------------------------------------------------------------------------
const toggleMenu = () => {
  $('.st-Header .hamburger button').on('click', function () {
    $(this).toggleClass("open");
    $(".st-Header nav").toggleClass("open");
    $(".st-Header").toggleClass("open");
  });
};


// ------------------------------------------------------------------------
// loadMovie
// ----- BOTH
// ------------------------------------------------------------------------
const loadMovie = () => {
  $(window).on('load', function () {
    if (/iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document) {
      $("#video").addClass("ipad");
    }
    $("#video").addClass("loaded");
  });
  $(window).on('load', function () {
    // let mvHeight = window.innerHeight;
    // $(".idx-Mainvisual").css("height",mvHeight);
    var video = document.getElementById('video');
    video.play();
  });
};


const moreBtn = () => {
  $(".more-app").on("click", function () {
    $(this).parent(".sw-Frame").addClass("show");
    // $(this).addClass("hide");
    return false;
  });
};

//termToggle
const termToggle = () => {
  $('.faq_List li dl dt').on('click', function () {
    $(this).next('dd').slideToggle(100).css('display', 'block');
    $(this).parent().toggleClass('opened')
  });
};

// ------------------------------------------------------------------------
// accordion
// ------------------------------------------------------------------------
const accordion = () => {
  $('.js-Accordion').each(function () {
    $(this).children('.heading').on("click", function () {
      $(this).next('.content').slideToggle();
      $(this).toggleClass('active');
    });
  });
};

//バナー
const bnr = () => {
  $("#live-Bnr .close").on("click", function () {
    $('#live-Bnr').addClass('closed');
  });
};


export {
  preLoad,
  anchorLink,
  scrollBanner,
  slideBanner,
  slideArtist,
  resizeHeader,
  toggleAccordion,
  toggleMenu,
  loadMovie,
  scrollAnimate,
  loadAnimate,
  moreBtn,
  termToggle,
  accordion,
  bnr
}


// WEBPACK FOOTER //
// ./src/assets/js/include/module.js